import { OTPTemplateVariables } from '@dehaat/kisan-app-bl/models/Order'

import { PAYMENT_OPTIONS } from '@/constants/payments'

export enum DELIVERY_TYPE {
  HOME_DELIVERY = 'home_delivery',
  SELF_PICKUP = 'pickup_from_store',
}

export enum DELIVERY_FULFILLMENT_TYPE {
  BOTH = 'both',
  HOME_DELIVERY = 'home_delivery',
  SELF_PICKUP = 'pickup_from_store',
}

export interface ProductOutOfStock {
  id: string
  brandName?: string
  productName?: string
  quantity?: string
  productImage?: string | null
}

export interface AvailbleStockError {
  item_id: string
  available_qty: number
  parent_type?: string
}

export interface CartValidationError {
  message: string
  details?: {
    product_variant_id: number
    catalog_id?: number
  }
  comboMessage?: string
  comboDetails?: {
    product_variant_id: number
  }
}

export interface OTPData {
  required: boolean
  template: OTPTemplateVariables
}

export interface OrderStatusDetails {
  showOrderStatus: boolean
  orderId?: string
  paymentOption: PAYMENT_OPTIONS
}
